import commitDarkModeTheme from './commitDarkModeTheme';
import { getIsDarkTheme } from 'owa-fabric-theme';

export default async function saveDarkModeOption() {
    commitDarkModeTheme(getIsDarkTheme());
}
